import { Box, Typography } from "@mui/material";
import { Controller } from "react-hook-form";

import { Checkbox, FormControlLabel, FormGroup } from "@/components/ui-v2";

import { EXPORT_FORM_FIELDS } from "../../../constants";

export const ExportFormOutputProcessors = () => (
  <Box>
    <Typography variant="small" fontWeight={600} sx={{ mb: 1 }}>
      Output Processors
    </Typography>
    <FormGroup>
      <Controller
        name={EXPORT_FORM_FIELDS.REMOVE_BACKGROUND}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox {...field} checked={field.value} size="small" />}
            label="Remove Background"
          />
        )}
      />
    </FormGroup>
  </Box>
);
